import React, { useEffect, useState } from "react";
import MemberPartnerDashboardWrapper from "../../../layout/wrapper/MemberPartnerDashboardWrapper";
import styles from "../../../styles/pages/user/qcagentdashboard/qcagent-dasboard.module.scss";
import { Box, Stack } from "@mui/system";
import {
  Button,
  Dialog,
  List,
  ListItem,
  Menu,
  MenuItem,
  Slide,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import QcPendingReview from "../../../ui/Icons/QcPendingReview";
import QcInquireVideo from "../../../ui/Icons/QcInquireVideo";
import QcAwaitingConfirmation from "../../../ui/Icons/QcAwaitingConfirmation";
import QcModalClose from "../../../ui/Icons/QcModalClose";
import QcVerifiedVideo from "../../../ui/Icons/QcVerifiedVideo";
import QcMessage from "../../../ui/Icons/QcMessage";
import PerfectScrollbar from "react-perfect-scrollbar";
import QcagentDashboardFilter from "../../../components/QcagentDashboardFilter/QcagentDashboardFilter";
import QcagentDashboardFilterCalendar from "../../../components/QcagentDashboardFilterCalendar/QcagentDashboardFilterCalendar";
import { Link, useNavigate } from "react-router-dom";
import QcArrow from "../../../ui/Icons/QcArrow";
import QcagentPendingTable from "../../../components/QcagentPendingTable/QcagentPendingTable";
import QcDashboardWrapper from "../../../layout/wrapper/QcDashboradWrapper";
import QcModalVideo from "../../../ui/Icons/QcModalVideo";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useQuery } from "react-query";
import { qcSubmissionsList } from "../../../api/functions/cms.api";
import useCalenderFilter from "../../../hooks/useCalenderFilter";
import CalenderDate from "../../Calender";
import {
  emptyHandleTwo,
  getDateApiFormat,
} from "../../../lib/functions/utils.lib";
import dayjs from "dayjs";
import QcTitlingModal from "./QcTitlingModal";
import QcPublicationModal from "./QcPublicationModal";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const QcagentDasboard = () => {
  const [value, setValue] = React.useState(0);

  // const { qcSubmisson } = useAppSelector((s) => s.appStateSlice);

  const [qcSubmisson, setQcSubmisson] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  useQuery(
    ["getQcSubmissons", from, to],
    () => qcSubmissionsList({ from, to }),
    {
      onSuccess: (res) => {
        // console.warn("qcdata", res.data);
        setQcSubmisson(res.data);
      },
    }
  );
  const calenderContainerId = "calender-input-filter-row";
  const {
    calenderFilter,
    DateFilterRangeList,
    calenderFilterShowValue,
    changeCalenderFilter,
    resetCalender,
    confirmedCalenderValue,
    calenderValue,
    confirmCalenderTwo,
    dateRangeFilter: {
      dateRangeFilterAnchor,
      openedDateRangeFilter,
      handleOpenDateRangeFilter,
      handleCloseDateRangeFilter,
    },
  } = useCalenderFilter({
    containerId: calenderContainerId,
  });

  useEffect(() => {
    if (calenderValue) {
      if (calenderValue[0]) {
        setFrom(getDateApiFormat(calenderValue[0]["$d"]));
      }
      if (calenderValue[1]) {
        setTo(getDateApiFormat(calenderValue[1]["$d"]));
      }
      // handleTriggreFetch();
    }
  }, [calenderValue]);

  // console.warn("qcSubmisson", qcSubmisson);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const reviewedVideo = [
    {
      videoType: "Approved",
      videoNumber: emptyHandleTwo(qcSubmisson?.reviewed_videos?.approved),
    },
    {
      videoType: "Rejected",
      videoNumber: emptyHandleTwo(qcSubmisson?.reviewed_videos?.rejected),
    },
    {
      videoType: "Website Only",
      videoNumber: emptyHandleTwo(qcSubmisson?.reviewed_videos?.website_only),
    },
    {
      videoType: "Duplicates",
      videoNumber: emptyHandleTwo(qcSubmisson?.reviewed_videos?.duplicates),
    },
  ];

  const confirmVideo = [
    {
      videoType: "Approved",
      videoNumber: emptyHandleTwo(
        qcSubmisson?.confirmed_videos?.approved_approved
      ),
    },
    {
      videoType: "Rejected",
      videoNumber: emptyHandleTwo(
        qcSubmisson?.confirmed_videos?.rejected_rejected
      ),
    },
    {
      videoType: "Website Only",
      videoNumber: emptyHandleTwo(
        qcSubmisson?.confirmed_videos?.website_website
      ),
    },
  ];

  const deniedVideo = [
    {
      videoType: "Approved",
      videoStatus: "Rejected",
      videoNumber: emptyHandleTwo(qcSubmisson?.denied?.approved_rejected),
    },
    {
      videoType: "Approved",
      videoStatus: "Website Only",
      videoNumber: emptyHandleTwo(qcSubmisson?.denied?.approved_website),
    },
    {
      videoType: "Rejected",
      videoStatus: "Approved",
      videoNumber: emptyHandleTwo(qcSubmisson?.denied?.rejected_approved),
    },
    {
      videoType: "Rejected",
      videoStatus: "Website Only",
      videoNumber: emptyHandleTwo(qcSubmisson?.denied?.rejected_website),
    },
    {
      videoType: "Website Only",
      videoStatus: "Approved",
      videoNumber: emptyHandleTwo(qcSubmisson?.denied?.website_approved),
    },
    {
      videoType: "Website Only",
      videoStatus: "Rejected",
      videoNumber: emptyHandleTwo(qcSubmisson?.denied?.website_rejected),
    },
  ];

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const [open, setOpen] = React.useState(false);
  const [openPending, setOpenPending] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickOpenPending = () => {
    setOpenPending(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClosePending = () => {
    setOpenPending(false);
  };

  const navigate = useNavigate();

  return (
    <>
      <QcDashboardWrapper>
        <Box className={styles.editorDashboardWrapper}>
          <Box className={styles.editorTab}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label={
                  <>
                    <Box
                      onClick={() =>
                        navigate("/qcagent-dashboard/submitted-videos/pending")
                      }
                      className={styles.tabItem}
                    >
                      <Box className={styles.tabitemImg}>
                        <QcPendingReview />
                      </Box>

                      <p>
                        Pending Review{" "}
                        <span>
                          {emptyHandleTwo(qcSubmisson?.submissions?.pending)}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(0)}
              />
              <Tab
                label={
                  <>
                    <Box
                      onClick={() =>
                        navigate(
                          "/qcagent-dashboard/submitted-videos/inquiring"
                        )
                      }
                      className={styles.tabItem}
                    >
                      <Box className={styles.tabitemImg}>
                        <QcInquireVideo />
                      </Box>

                      <p>
                        Inquiring Videos{" "}
                        <span>
                          {emptyHandleTwo(qcSubmisson?.submissions?.inquiry)}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(1)}
              />
              <Tab
                label={
                  <>
                    <Box
                      onClick={() =>
                        navigate(
                          "/qcagent-dashboard/awating-confirmation/approved"
                        )
                      }
                      className={styles.tabItem}
                    >
                      <Box className={styles.tabitemImg}>
                        <QcAwaitingConfirmation />
                      </Box>

                      <p>
                        Awaiting Confirmation{" "}
                        <span>
                          {emptyHandleTwo(
                            qcSubmisson?.submissions?.awaiting_confirmation
                          )}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(2)}
              />
              <Tab
                label={
                  <>
                    <Box
                      onClick={() =>
                        navigate(
                          "/qcagent-dashboard/qc-verified-videos-confirmed"
                        )
                      }
                      className={styles.tabItem}
                    >
                      <Box className={styles.tabitemImg}>
                        <QcVerifiedVideo />
                      </Box>

                      <p>
                        Verified Videos{" "}
                        <span>
                          {emptyHandleTwo(qcSubmisson?.submissions?.verified)}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(3)}
              />
              <Tab
                label={
                  <>
                    <Box
                      onClick={() => navigate("/qcagent-dashboard/qc-message")}
                      className={styles.tabItem}
                    >
                      <Box className={styles.tabitemImg}>
                        <QcMessage />
                      </Box>

                      <p>
                        Open Messages{" "}
                        <span>
                          {emptyHandleTwo(
                            qcSubmisson?.submissions?.open_message
                          )}
                        </span>
                      </p>
                    </Box>
                  </>
                }
                {...a11yProps(4)}
              />
            </Tabs>
          </Box>
        </Box>

        <Box className={styles.qaDashboardBody}>
          <PerfectScrollbar className={styles.dashboard_scroll_val}>
            <CustomTabPanel value={value} index={0}>
              <Box className={styles.qaDashboardBodyWrapper}>
                <Box className={styles.reviewVideoTabMain}>
                  <Box className={styles.single_rreview_tab}>
                    <Box className={styles.reviewd_filter_wrap}>
                      {/* <QcagentDashboardFilterCalendar /> */}

                      <Box className="commonSearchBar_modal">
                        <p>
                          Showing Data For{" "}
                          {calenderFilter ? (
                            <>
                              <Box
                                className={`dayList ${
                                  openedDateRangeFilter
                                    ? "date-black"
                                    : "date-blue"
                                }`}
                              >
                                <Button
                                  aria-haspopup="true"
                                  onClick={handleOpenDateRangeFilter}
                                >
                                  {calenderFilter?.name}
                                </Button>
                                <Menu
                                  anchorEl={dateRangeFilterAnchor}
                                  open={openedDateRangeFilter}
                                  onClose={handleCloseDateRangeFilter}
                                  className="dateList"
                                >
                                  {DateFilterRangeList.map((filter) => {
                                    if (filter != calenderFilter) {
                                      return (
                                        <MenuItem
                                          onClick={changeCalenderFilter(filter)}
                                          key={filter.name}
                                          selected={filter === calenderFilter}
                                        >
                                          {filter.name}
                                        </MenuItem>
                                      );
                                    }
                                  })}
                                </Menu>
                              </Box>
                              <span className="dateList">
                                ({calenderFilterShowValue})
                              </span>
                            </>
                          ) : (
                            <>
                              the period from{" "}
                              {confirmedCalenderValue?.[0] ? (
                                <span className="dayList">
                                  {dayjs(confirmedCalenderValue?.[0]).format(
                                    "LL"
                                  )}
                                </span>
                              ) : null}{" "}
                              to{" "}
                              {calenderValue?.[1] ? (
                                <span className="dayList">
                                  {dayjs(confirmedCalenderValue?.[1]).format(
                                    "LL"
                                  )}
                                </span>
                              ) : null}
                            </>
                          )}
                        </p>
                        {calenderFilter?.name !== "All time" ? (
                          <span
                            className="reset_picker"
                            onClick={resetCalender}
                          >
                            <svg
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M5.5 10C7.975 10 10 7.975 10 5.5C10 3.025 7.975 1 5.5 1C3.025 1 1 3.025 1 5.5C1 7.975 3.025 10 5.5 10Z"
                                stroke="currentColor"
                                strokeLinecap="round"
                                stroke-linejoin="round"
                              ></path>
                              <path
                                d="M4.22705 6.7832L6.77263 4.23762"
                                stroke="currentColor"
                                strokeWidth="0.8"
                                strokeLinecap="round"
                                stroke-linejoin="round"
                              ></path>
                              <path
                                d="M6.77263 6.76238L4.22705 4.2168"
                                stroke="currentColor"
                                strokeWidth="0.8"
                                strokeLinecap="round"
                                stroke-linejoin="round"
                              ></path>
                            </svg>
                            reset
                          </span>
                        ) : null}
                      </Box>

                      <CalenderDate confirmCalender={confirmCalenderTwo} />
                    </Box>

                    {/* <Box className={styles.approved_videos_table_wrap}>
                      <RejectedVideoTable />
                    </Box> */}

                    <Box className={styles.videoType_wpr}>
                      <Stack
                        className={styles.videoType_row}
                        direction="row"
                        gap={3}
                      >
                        <Box className={styles.videoType_col}>
                          <Box className={styles.videoType_box}>
                            <Typography variant="h3">
                              My Reviewed Videos
                              <Typography variant="caption">
                                {emptyHandleTwo(
                                  qcSubmisson?.reviewed_videos?.total
                                )}
                              </Typography>
                            </Typography>
                            <List className={styles.videoCmn_list}>
                              {reviewedVideo.map((videoValue, index) => (
                                <>
                                  <ListItem>
                                    <Link to="" key={index}>
                                      <Box
                                        className={styles.videoCmn_list_left}
                                      >
                                        <Typography variant="caption">
                                          {videoValue.videoType}
                                        </Typography>
                                      </Box>
                                      <Box
                                        className={styles.videoCmn_list_right}
                                      >
                                        <Typography variant="caption">
                                          {videoValue.videoNumber}
                                        </Typography>
                                      </Box>
                                    </Link>
                                  </ListItem>
                                </>
                              ))}
                            </List>
                          </Box>
                        </Box>
                        <Box className={styles.videoType_col}>
                          <Box className={styles.videoType_box}>
                            <Typography variant="h3">
                              Confirmed Videos
                              <Typography variant="caption">
                                {emptyHandleTwo(
                                  qcSubmisson?.confirmed_videos?.total
                                )}
                              </Typography>
                            </Typography>

                            <List className={styles.videoCmn_list}>
                              {confirmVideo.map((videoValue, index) => (
                                <>
                                  <ListItem key={index}>
                                    <Link to="">
                                      <Box
                                        className={styles.videoCmn_list_left}
                                      >
                                        <Typography
                                          variant="caption"
                                          className={styles.video_type_captions}
                                        >
                                          {videoValue.videoType}
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          className={
                                            styles.arrows_type_captions
                                          }
                                        >
                                          <QcArrow />
                                        </Typography>
                                        <Typography variant="caption">
                                          {videoValue.videoType}
                                        </Typography>
                                      </Box>
                                      <Box
                                        className={styles.videoCmn_list_right}
                                      >
                                        <Typography variant="caption">
                                          {videoValue.videoNumber}
                                        </Typography>
                                      </Box>
                                    </Link>
                                  </ListItem>
                                </>
                              ))}
                            </List>
                          </Box>
                        </Box>
                        <Box className={styles.videoType_col}>
                          <Box className={styles.videoType_box}>
                            <Typography variant="h3">
                              Denied Videos
                              <Typography variant="caption">
                                {emptyHandleTwo(qcSubmisson?.denied?.total)}
                              </Typography>
                            </Typography>

                            <List className={styles.videoCmn_list}>
                              {deniedVideo.map((videoValue, index) => (
                                <>
                                  <ListItem>
                                    <Link to="" key={index}>
                                      <Box
                                        className={styles.videoCmn_list_left}
                                      >
                                        <Typography
                                          variant="caption"
                                          className={styles.video_type_captions}
                                        >
                                          {videoValue.videoType}
                                        </Typography>
                                        <Typography
                                          variant="caption"
                                          className={
                                            styles.arrows_type_captions
                                          }
                                        >
                                          <QcArrow />
                                        </Typography>
                                        <Typography variant="caption">
                                          {videoValue.videoStatus}
                                        </Typography>
                                      </Box>
                                      <Box
                                        className={styles.videoCmn_list_right}
                                      >
                                        <Typography variant="caption">
                                          {videoValue.videoNumber}
                                        </Typography>
                                      </Box>
                                    </Link>
                                  </ListItem>
                                </>
                              ))}
                            </List>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>

                    <Box className={styles.videoLink_wpr}>
                      <Stack
                        className={styles.videoType_row}
                        direction="row"
                        gap={3}
                      >
                        <Box className={styles.videoType_col}>
                          <Box className={styles.videoType_box}>
                            <Typography variant="h3">
                              <Link to="">
                                Verified videos
                                <Typography variant="caption">
                                  {emptyHandleTwo(qcSubmisson?.total?.verified)}
                                </Typography>
                              </Link>
                            </Typography>
                          </Box>
                        </Box>
                        <Box className={styles.videoType_col}>
                          <Box className={styles.videoType_box}>
                            <Typography variant="h3">
                              <Link to="" onClick={handleClickOpen}>
                                Videos Pending Titling
                                <Typography variant="caption">
                                  {emptyHandleTwo(
                                    qcSubmisson?.total?.pendingTitling
                                  )}
                                </Typography>
                              </Link>
                            </Typography>
                          </Box>
                        </Box>
                        <Box className={styles.videoType_col}>
                          <Box className={styles.videoType_box}>
                            <Typography variant="h3">
                              <Link to="" onClick={handleClickOpenPending}>
                                Videos Pending Publication
                                <Typography variant="caption">
                                  {emptyHandleTwo(
                                    qcSubmisson?.total?.pendingPublication
                                  )}
                                </Typography>
                              </Link>
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CustomTabPanel>
          </PerfectScrollbar>
        </Box>
        <QcTitlingModal open={open} handleClose={handleClose} />
        <QcPublicationModal
          open={openPending}
          handleClose={handleClosePending}
        />
      </QcDashboardWrapper>
    </>
  );
};

export default QcagentDasboard;
